import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 12h12","key":"svg-0"}],["path",{"d":"M9 5v14","key":"svg-1"}],["path",{"d":"M16 19a7 7 0 0 0 -7 -7a7 7 0 0 0 7 -7","key":"svg-2"}]]

/**
 * IconCurrencyKip
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY3VycmVuY3kta2lwIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik02IDEyaDEyIiAvPgogIDxwYXRoIGQ9Ik05IDV2MTQiIC8+CiAgPHBhdGggZD0iTTE2IDE5YTcgNyAwIDAgMCAtNyAtN2E3IDcgMCAwIDAgNyAtNyIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/currency-kip
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCurrencyKip = createReactComponent('outline', 'currency-kip', 'CurrencyKip', __iconNode);

export default IconCurrencyKip;